// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ExitRequest_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExitRequest = void 0;
const typedjson_1 = require("../../export/typedjson");
const transaction_1 = require("./transaction");
const exitTypeName = "ExitRequest";
let ExitRequest = ExitRequest_1 = class ExitRequest extends transaction_1.Transaction {
    txType() {
        return ExitRequest_1;
    }
    txTypeName() {
        return exitTypeName;
    }
    encodeABI(_e, _) {
        return "ErdstallExitRequest";
    }
};
ExitRequest = ExitRequest_1 = __decorate([
    typedjson_1.jsonObject
], ExitRequest);
exports.ExitRequest = ExitRequest;
transaction_1.registerTransactionType(exitTypeName, ExitRequest);
//# sourceMappingURL=exitrequest.js.map